import { noopComposerLlm } from './noop';
import type { ComposerLlm } from './types';

/**
 * Factory (ADR-053): `JOURNEY_COMPOSER_LLM_PROVIDER` selects the backend —
 * `noop` (safe default, generation-unavailable sentinel) or `bedrock`. The
 * Bedrock concrete lives with its consumer (it pulls the AWS SDK, which this
 * package must not depend on), so unlike the memory factory it is INJECTED by
 * the caller rather than imported here.
 *
 * An unrecognised value throws (ADR-053 Rule 4 — misconfiguration must be
 * loud). `bedrock` selected without an injected concrete is a recognised
 * value in an incomplete wiring state, and resolves to the noop: its
 * sentinel never Zod-parses as a plan, so the run degrades to the
 * deterministic fallback tier instead of failing outright.
 */
export function getComposerLlm(overrides?: Partial<Record<'bedrock', ComposerLlm>>): ComposerLlm {
  const selected = process.env.JOURNEY_COMPOSER_LLM_PROVIDER ?? 'noop';
  if (selected === 'noop') return noopComposerLlm;
  if (selected === 'bedrock') return overrides?.bedrock ?? noopComposerLlm;
  throw new Error(`journey-composer-llm: unrecognised JOURNEY_COMPOSER_LLM_PROVIDER "${selected}"`);
}
